form = {
    lat: 0,
    lon: 0,
    address: '',
    city: '',
    state: '',
    zip: '',
    country: '',
};

function initMap() {
    var map = new google.maps.Map(document.getElementById('map'), {
        center: {lat: 38.252620, lng: -85.736941},
        zoom: 13
    });
    var geocoder = new google.maps.Geocoder;
    var autocomplete = new google.maps.places.Autocomplete(document.getElementById('address'));
    // Bind the map's bounds (viewport) property to the autocomplete object,
    // so that the autocomplete requests use the current map bounds for the
    // bounds option in the request.
    autocomplete.bindTo('bounds', map);
    var infowindow = new google.maps.InfoWindow();
    var infowindowContent = document.getElementById('infowindow-content');
    infowindow.setContent(infowindowContent);
    var marker = new google.maps.Marker({
        map: map,
        anchorPoint: new google.maps.Point(0, -29)
    });

    document.getElementById("geolocate-btn").addEventListener("click", function() {
        $('#address').val('');
        $("#confirm-address").fadeOut("fast");
        $('#map-container').css('opacity', 0);
        if (navigator.geolocation) {
            document.getElementById("geolocate-error").style.display = "none";
            document.getElementById("loader").style.display = "block";
            var over = '<div id="loading-overlay">' + '<p>Calculating Your Current Location</p>' + '</div>';
            $(over).appendTo('body');
            navigator.geolocation.getCurrentPosition(function(position) {
                var pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                $('#map-container').css('opacity', 1);
                infowindow.open(map);
                map.setCenter(pos);
                map.setZoom(16);
                marker.setPosition(pos);
                marker.setVisible(true);
                $("#confirm-address").fadeIn("fast");
                document.getElementById("loader").style.display = "none";
                $('#loading-overlay').remove();
                geocoder.geocode({'location': pos}, function(results, status) {
                    if (status === 'OK') {
                        if (results[0]) {
                            infowindow.setContent(results[0].formatted_address);
                            infowindow.open(map, marker);
                            $('#address').val(results[0].formatted_address);
                            var address = '';
                            if (results[0].address_components) {
                                address = [
                                    (results[0].address_components[0] && results[0].address_components[0].short_name || ''),
                                    (results[0].address_components[1] && results[0].address_components || ''),
                                    (results[0].address_components[2] && results[0].address_components[2].short_name || '')
                                ].join(' ');
                                form.lat = position.coords.latitude;
                                form.lon = position.coords.longitude;
                                var parsed = placeToAddress(results[0]);
                                form.address = parsed.number + ' ' + parsed.street;
                                form.city = parsed.city;
                                form.state = parsed.state;
                                form.zip = parsed.zip;
                                form.country = parsed.country;
                            }
                            //   $('#address').trigger('place_changed');
                            // form.lat = position.coords.latitude;
                            // form.lon = position.coords.longitude;
                            // // var parsed = placeToAddress(place);
                            // form.address = results[0].address_components[0].long_name + ' ' + results[0].address_components[1].long_name;
                            // form.city = results[0].address_components[3].long_name;
                            // form.state = results[0].address_components[5].long_name;
                            // form.zip = results[0].address_components[7].long_name;
                            // form.country = results[0].address_components[6].long_name;
                        } else {
                            console.log('No street address found');
                        }
                    } else {
                        window.alert('Geocoder failed due to: ' + status);
                    }
                });
            },
            function (error) {
                if (error.code == error.PERMISSION_DENIED)
                document.getElementById("loader").style.display = "none";
                $('#loading-overlay').remove();
                document.getElementById("geolocate-error").style.display = "block";
                console.log("Error - Geolocation PERMISSION_DENIED")
            });
        } else {
            // Browser doesn't support Geolocation
            alert("Geolocation is not supported by this browser.");
        }
    });

    autocomplete.addListener('place_changed', function() {
        $('#map-container').css('opacity', 1);
        infowindow.close();
        marker.setVisible(false);
        var place = autocomplete.getPlace();
        if (!place.geometry) {
            // User entered the name of a Place that was not suggested and
            // pressed the Enter key, or the Place Details request failed.
            window.alert("No details available for input: '" + place.name + "'");
            return;
        }
        // If the place has a geometry, then present it on a map.
        if (place.geometry.viewport) {
            map.fitBounds(place.geometry.viewport);
        } else {
            map.setCenter(place.geometry.location);
            map.setZoom(17);  // Why 17? Because it looks good.
        }
        marker.setPosition(place.geometry.location);
        marker.setVisible(true);
        var address = '';
        if (place.address_components) {
            address = [
                (place.address_components[0] && place.address_components[0].short_name || ''),
                (place.address_components[1] && place.address_components[1].short_name || ''),
                (place.address_components[2] && place.address_components[2].short_name || '')
            ].join(' ');
            form.lat = place.geometry.location.lat();
            form.lon = place.geometry.location.lng();
            var parsed = placeToAddress(place);
            form.address = parsed.number + ' ' + parsed.street;
            form.city = parsed.city;
            form.state = parsed.state;
            form.zip = parsed.zip;
            form.country = parsed.country;
        }
        infowindow.setContent(infowindowContent);
        infowindowContent.children['place-icon'].src = place.icon;
        infowindowContent.children['place-name'].textContent = place.name;
        infowindowContent.children['place-address'].textContent = address;
        infowindow.open(map, marker);
        $("#confirm-address").fadeIn("fast");
    });
}

$("#address-accept").click(function(e) {
    $('#lat').val(form.lat);
    $('#lon').val(form.lon);
    $('#address_result').val(form.address);
    $('#city').val(form.city);
    $('#state').val(form.state);
    $('#zip').val(form.zip);
    $('#country').val(form.country);
    $('#location-form').submit();
});

$("#address-reject").click(function(e) {
    window.location.reload();
});

$(document).on("keypress", "form", function(event) {
    return event.keyCode != 13;
});

function placeToAddress(place) {
    var address = {};
    place.address_components.forEach(function(c) {
        switch (c.types[0]) {
            case 'street_number':
                address.number = c.long_name;
                break;
            case 'route':
                address.street = c.long_name;
                break;
            case 'neighborhood': case 'locality':    // North Hollywood or Los Angeles?
                address.city = c.long_name;
                break;
            case 'administrative_area_level_1':     //  Note some countries don't have states
                address.state = c.long_name;
                break;
            case 'postal_code':
                address.zip = c.long_name;
                break;
            case 'country':
                address.country = c.long_name;
                break;
        }
    });
    if (address.number == undefined) {
        number = $.trim($("#address").val()).split(" ")[0];
        if ($.isNumeric(number)) {
            address.number = number;
        }
    }
    return address;
}

//# sourceMappingURL=location.js.map
